<template>

<div class="list-view no-sub-header">
	<div class="filters">
		<div v-if="view == 'enrollment' && filters.class_detail_id && filters.reservation_date">
			<div class="button action" @click="selectedCustomer = {}; showAddEnrollment = true">Enroll a Customer</div>
			<div class="button neutral" @click="backToEnrollmentList()">Back to List</div>
			<div v-if="$route.query.from == 'calendar'" class="button neutral" @click="backToCalendar()">Back to Calendar</div>
		</div>
		<div v-else>
			<label>Class</label>
			<select v-model="filters.class_detail_id" @change="getList()">
				<option value="">All Classes</option>
				<option v-for="(classDetail, classDetailId) in classList" :value="classDetailId">{{ classDetail }}</option>
			</select>
			<label>View</label>
			<select v-model="view" @change="$router.push('/range-memberships/class-calendar/' + view)">
				<option value="calendar">Calendar</option>
				<option value="enrollment">Enrollment</option>
			</select>
			<div v-if="view == 'enrollment'">
				<div class="label-group">
					<label>Start</label>
						<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
				</div>
				<div class="label-group">
					<label>End</label>
					<input type="date" v-model="filters.end_date" :min="$today().clone().format('YYYY-MM-DD')">
				</div>
				<div class="label-group">
					<label></label>
					<div class="button small neutral" @click="getList()">Filter Dates</div>
				</div>
			</div>
			<label>Status</label>
			<select v-model="filters.status" @change="filterStatus()">
				<option value="">Any</option>
				<option value="full">Enrollment Full</option>
				<option value="available">Seats Still Available</option>
			</select>
		</div>
		<div v-if="view == 'enrollment'">
			<div class="divider"></div>
			<div class="extra-menu-item" @click="exportList()">Export Enrollment List</div>
		</div>
	</div>

	<loading v-if="loading" class="loading"></loading>

	<div v-else-if="view == 'calendar'" class="detail no-sub-header">
		<h3>{{ calendarTitle }}</h3>
		<calendar-view 
			:show-date="showDate"
			:items="calendarItems"
			currentPeriodLabel="•"
			itemContentHeight="2.5em"
			:periodChangedCallback="changeMonth"
			:showTimes=false
			@click-item="showCalendarItemDetail"
			class="theme-default holiday-us-traditional holiday-us-official">
			<template #header="{ headerProps }">
				<calendar-view-header
					:header-props="headerProps"
					@input="setShowDate" />
			</template>
		</calendar-view>
	</div>

	<div v-else-if="view == 'enrollment' && filters.class_detail_id && filters.reservation_date" class="list">
		<div class="detail">
			<div style="margin: 0 0 1em 0;">
				<h3>{{ enrollmentClassDetail.description }} {{ $moment(filters.reservation_date).format('MM/DD/YYYY') }} <span v-if="selectedClassTimeLabel">{{ selectedClassTimeLabel }}</span></h3>
				Total Seats {{ enrollmentClassDetail.seats_available }}, Enrolled {{ enrollmentList.length }}, Available {{ selectedAvailableSeats}}
			</div>
			<div v-if="enrollmentList.length == 0" class="empty-list">
				No enrollments for this class.
			</div>
			<table v-else class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list">Name</th>
						<th class="list">Phone</th>
						<th class="list">Email</th>
						<th class="center">Is Member</th>
					</tr>
				</thead>
				<tr v-for="(enrollment, index) in enrollmentList" class="clickable-list-item" @click="contactDetail(enrollment)">
					<td class="list left">{{ enrollment.first_name }} {{ enrollment.last_name }}</td>
					<td class="list left">{{ enrollment.phone_number }}</td>
					<td class="list left">{{ enrollment.email_address }}</td>
					<td class="list center"><i v-if="enrollment.membership_id" class="fa fa-check"></i></td>
				</tr>
			</table>
		</div>
	</div>

	<div v-else-if="view == 'enrollment'" class="detail">
		<h3>{{ enrollmentTitle }}</h3>
		<div v-if="enrollmentList.length == 0" class="empty-list">
	        This list is empty
	    </div>
		<div v-else class="list">
        <table class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Date</th>
					<th class="list">Time</th>
					<th class="list">Description</th>
					<th class="list">UPC</th>
					<th class="right">Seats</th>
					<th class="right">Enrolled</th>
					<th class="right">Available</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in enrollmentList" class="clickable-list-item" @click="getClassEnrollment(item)">
                <td class="list left">{{ $moment(item.reservation_date).format('MM/DD/YYYY') }}</td>
                <td class="list left">{{ item.start_time }} - {{ item.end_time }}</td>
                <td class="list left">{{ item.description }}</td>
                <td class="list left">{{ item.upc }}</td>
                <td class="list right">{{ item.seats_available }}</td>
                <td class="list right">{{ item.reservations }}</td>
                <td class="list right">{{ item.seats_available - item.reservations }}</td>
            </tr>
        </table>
		</div>
	</div>

	<div v-if="enrollmentDetail.contact_id" class="modal medium-modal">
		<div class="inner" style="max-height: calc(100vh - 10em);">
			<h2>Enrolled Customer</h2>
			<div class="content" style="max-height: calc(100vh - 10em);">
				<div class="four-one-columns align-items-end">
					<div class="two-columns">
						<div>
							<label class="full">Class Name</label>
							<b>{{ enrollmentDetail.description }}</b>
						</div>
						<div>
							<label class="full">Class Date</label>
							<b>{{ $moment(enrollmentDetail.reservation_date).format('MM/DD/YY') }}</b>
						</div>
					</div>
					<div>
						<div :class="['button', confirmCancelEnrollment ? 'disabled' : 'neutral', 'smaller']" @click="confirmCancelEnrollment = true">Cancel Enrollment</div>
					</div>
					<div v-if="confirmCancelEnrollment" style="padding: 1em;">
						<div class="v-spaced">
							<div v-if="enrollmentDetail.order_info">Order number {{ enrollmentDetail.order_info.order_number }} will not be refunded, you'll need to handle that in POS.</div>
							Are you sure you want to cancel this enrollment?
						</div>
						<div :class="['button', saving ? 'disabled' : 'neutral', 'inline', 'spaced']" @click="confirmCancelEnrollment = false">No</div>
						<div :class="['button', saving ? 'disabled' : 'neutral', 'inline', 'spaced']" @click="cancelEnrollment()">Yes, Cancel</div>
						<div v-if="saving == 'cancel_enrollment'" class="message"><i class="fa fa-spinner fa-spin"></i> Cancelling enrollment...</div>
					</div>
				</div>
				<div v-if="enrollmentDetail.order_info" class="divider"></div>
				<div v-if="enrollmentDetail.order_info" class="four-one-columns align-items-end">
					<div class="two-columns">
						<div>
							<label class="full">Order Number</label>
							<b>{{ enrollmentDetail.order_info.order_number }}</b>
						</div>
						<div>
							<label class="full">Order Date</label>
							<b>{{ enrollmentDetail.order_info.order_date }}</b>
						</div>
					</div>
					<div :class="['button', saving ? 'disabled' : 'neutral', 'smaller']" @click="$router.push('/orders-sales/orders/detail/' + enrollmentDetail.order_info.order_id)">View Order</div>
				</div>
				<div class="divider"></div>
				<div class="four-one-columns align-items-end">
					<div>
						<div class="two-columns">
							<div><label class="full">First Name</label>
								<b>{{ enrollmentDetail.first_name }}</b></div>
							<div><label class="full">Last Name</label>
								<b>{{ enrollmentDetail.last_name }}</b></div>
						</div>
						<div class="two-columns v-spaced">
							<div><label class="full">Email Address</label>
								<b>{{ enrollmentDetail.email_address }}</b></div>
							<div><label class="full">Phone Number</label>
								<b>{{ enrollmentDetail.phone_number }}</b></div>
						</div>
						<div class="two-columns v-spaced">
							<div><label class="full">Birthdate</label>
								<b>{{ enrollmentDetail.birthdate ? $moment(enrollmentDetail.birthdate).format('MM/DD/YYYY') : 'N/A' }}</b></div>
							<div><label class="full">Membership</label>
								<b>{{ enrollmentDetail.membership_info ? enrollmentDetail.membership_info.description : 'N/A' }}</b></div>
						</div>
					</div>
					<div style="margin: 0 0 0.5em 0;">
						<div :class="['button', saving ? 'disabled' : 'neutral', 'smaller']" style="width: 100%;" @click="$router.push('/customers/contacts/' + (enrollmentDetail.order_info ? enrollmentDetail.order_info.contact_id : enrollmentDetail.contact_id))">Edit Customer</div>
					</div>
				</div>

				<div class="divider"></div>
				<div><b>Notifications</b></div>
				<div v-if="enrollmentDetail.enable_email_reminder || enrollmentDetail.enable_text_reminder" class="two-columns">
					<div>
						<div>Customer <b>opted {{ enrollmentDetail.email_notifications ? 'in to' : 'out of' }}</b> email notifications</div>
						<div>Customer <b>opted {{ enrollmentDetail.text_notifications ? 'in to' : 'out of' }}</b> text notifications</div>
					</div>
					<div>
						<div v-for="(notification, index) in enrollmentDetail.notifications">
							{{ $moment(notification.log_time).format('MM/DD/YYYY') }}  
							{{ notification.phone_number ? 'Text' : 'Email' }} {{ notification.message_id == 'ERROR' ? 'failed' : 'sent' }} to {{ notification.phone_number || notification.email_address }}
						</div>
					</div>
				</div>
				<div v-else>
					This class does not have notifications enabled.
				</div>

				<div class="divider"></div>
				<div><b>Move this enrollment</b></div>
				<div class="four-one-columns align-center">
					<div class="two-columns">
						<div>
							<label class="full">Move to Class</label>
							<select @change="resetMoveClass()" v-model="enrollmentDetail.class_detail_id">
								<option value="">Select a class...</option>
								<option v-for="(classDetail, classDetailId) in classList" :value="classDetailId">{{ classDetail }}</option>
							</select>
							<label class="full">Seat Availability</label>
							<input 
								type="text" 
								:value="seatAvailability" 
								:disabled="true" 
								readonly 
							/>
						</div>
						<div>
							<label class="full">Move to Date</label>
							<select v-if="enrollmentDetailDetailDates && enrollmentDetailDetailDates.length > 0" v-model="enrollmentDetail.move_selection" @change="setMoveClassDateId()">
								<option value="">Select a date...</option>
								<option v-for="date in enrollmentDetailDetailDates" :key="date.move_key" :value="date.move_key">{{ formatMoveOption(date) }}</option>
							</select>
						</div>
					</div>
					<div style="margin: 0.5em 0 0 0;">
						<div :class="['button', saving ? 'disabled' : 'neutral', 'smaller']" style="width: 100%;" @click="moveEnrollment()">Save Move</div>
					</div>
					<div v-if="saving == 'move_enrollment'"><i class="fa fa-spinner fa-spin"></i> Moving enrollment...</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="enrollmentDetail = {}">Close</div>
			</div>
		</div>
	</div>

	<div v-if="showAddEnrollment" class="modal">
		<div class="inner">
			<h2>Enroll a Customer in This Class</h2>
			<div class="content">
				<label>Search for a customer to enroll...</label>
				<div class="input-with-control">
					<input type="search" ref="search_term" v-model="customerSearchTerm" placeholder="Search..." @search="searchCustomers()" v-focus>
					<div :class="['button', searching || !customerSearchTerm ? 'disabled' : 'action', 'input-go']" @click="searchCustomers()"><i class="fas fa-search"></i></div>
				</div>
				<div v-if="saving == 'add_enrollment'" class="message"><i class="fa fa-spinner fa-spin"></i> Adding enrollment...</div>
				<ul v-else-if="!selectedCustomer.contact_id" class="clickable-list">
					<li v-for="(customer, index) in customerList" class="clickable-list-item" @click="setSelectedCustomer(customer)">
						{{ customer.full_name }}<br>
						{{ customer.address_1 }}<br>
						{{ customer.city }} {{ customer.state }} {{ customer.zip_code }}
						<div v-if="customer.phone_number"><label>Phone</label> {{ customer.phone_number }}</div>
						<div v-if="customer.email_address"><label>Email</label> {{ customer.email_address }}</div>
					</li>
				</ul>
				<div v-else>
					<b>Selected Customer</b><br>
					{{ selectedCustomer.full_name }}<br>
					{{ selectedCustomer.address_1 }}<br>
					{{ selectedCustomer.city }} {{ selectedCustomer.state }} {{ selectedCustomer.zip_code }}
					<div v-if="selectedCustomer.phone_number"><label>Phone</label> {{ selectedCustomer.phone_number }}</div>
					<div v-if="selectedCustomer.email_address"><label>Email</label> {{ selectedCustomer.email_address }}</div>

					<div v-if="enrollmentClassDetail.enable_email_reminder || enrollmentDetail.enable_text_reminder">
						<div style="margin: 1em 0 0 0;"><b>Notifications</b></div>
						<div v-if="selectedCustomer.email_address || selectedCustomer.phone_number" class="two-columns">
							<div v-if="enrollmentClassDetail.enable_email_reminder && selectedCustomer.email_address">
								<input checked type="checkbox" v-model="selectedCustomer.email_notifications"/>
								<label>Send email notifications for class.</label>
							</div>
							<div v-if="enrollmentClassDetail.enable_text_reminder && selectedCustomer.phone_number">
								<input checked type="checkbox" v-model="selectedCustomer.text_notifications"/>
								<label>Send text notifications for class.</label>
							</div>
						</div>
					</div>
					<div v-else>
						This class does not have notifications enabled.
					</div>
				</div>

			</div>
			<div class="controls">
				<div :class="['button', selectedCustomer.contact_id ? 'action' : 'disabled', 'spaced']" @click="addToEnrollment(selectedCustomer)">Enroll Customer</div>
				<div class="button cancel spaced" @click="showAddEnrollment = ''">Cancel</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>

import Loading from '@/components/Loading.vue'

// We use version 5! npm i vue-simple-calendar@5.0.1
import 'vue-simple-calendar/static/css/default.css'
import {CalendarView, CalendarViewHeader} from 'vue-simple-calendar'
//import CalendarView from "vue-simple-calendar/src/components/CalendarView.vue"
//import CalendarViewHeader from "vue-simple-calendar/src/components/CalendarViewHeader.vue"

export default {
	name: 'class-calendar',
	props: ['class_detail_id'],
    components: {
        'loading': Loading,
		'calendar-view': CalendarView,
		'calendar-view-header': CalendarViewHeader
    },
	data() {
		return {
            loading: false,
			saving: '',
			searching: false,
            message: '',
            messageStatus: '',
            messageTimeout: 0,
			view: 'calendar',
			filters: {},
			showDetail: false,
			classList: {},
			calendarList: {},
			enrollmentClassDetail: {},
			enrollmentList: [],
			enrollmentDetail: {},
			confirmCancelEnrollment: false,
			paging: {},
			showDate: new Date(),
			today: '',
			showAddEnrollment: false,
			customerSearchTerm: '',
			searchMessage: '',
			seatAvailability: '--',
			customerList: [],
			searching: false,
			selectedCustomer: {},
			gettingExport: false,
			exportMessage: '',
			invalidClass: false, 
			selectedClassStartTime: '', 
			selectedClassEndTime: '', 
			selectedClassSeatsAvailable: null
		}
	},
	created() {
		if (this.$route.path.indexOf('/enrollment') > -1) {
			this.view = 'enrollment'
		} else {
			this.view = 'calendar'
		}
		this.today = this.showDate.getFullYear() + '-' + (this.showDate.getMonth() + 1).toString().padStart(2,'0') + '-' + this.showDate.getDate().toString().padStart(2,'0')
		this.clearFilters()
		this.getList()
	},
	computed: {
		calendarTitle() {
			let title = ''
			if (this.filters.class_detail_id) {
				title += this.classList[this.filters.class_detail_id]
			}
			if (this.filters.status) {
				title += ' (' + this.filters.status + ')'
			}
			return title || 'All Classes'
		},
		enrollmentTitle() {
			let title = ''
			if (this.filters.class_detail_id) {
				title += this.classList[this.filters.class_detail_id]
			}
			if (this.filters.status) {
				title += ' (' + this.filters.status + ')'
			}
			return title || 'All Enrollments'
		},
		enrollmentDetailDetailDates() {
			if (!this.enrollmentDetail.class_detail_id) {
				return []
			}
			return this.populateCalendarItems(this.today, this.enrollmentDetail.class_detail_id) || []
		}, 
		selectedEnrollmentCount() {
			return Array.isArray(this.enrollmentList) ? this.enrollmentList.length : 0 
		}, 
		selectedAvailableSeats() {
			const totalSeats = Number(this.enrollmentClassDetail.seats_available || 0)
			return Math.max(totalSeats - this.selectedEnrollmentCount, 0)
		}, 
		selectedClassTimeLabel() {
			if (this.selectedClassStartTime && this.selectedClassEndTime) {
				return `(${this.selectedClassStartTime} - ${this.selectedClassEndTime})`
			}
			return '' 
		}
	},
    watch: {
		view: function() {
			this.getList()
		}
	},
	methods: {
		clearFilters() {
			let firstDayOfMonth = new Date(this.showDate.getFullYear(), this.showDate.getMonth(), 1).toISOString().slice(0, 10);
			let lastDayOfMonth = new Date(this.showDate.getFullYear(), this.showDate.getMonth() + 1, 0).toISOString().slice(0, 10);

			this.filters = {
				class_detail_id: '',
				class_date_id: '',
				reservation_date: '',
				start_date: firstDayOfMonth,
				end_date: lastDayOfMonth,
				status: '',
				search_term: '',
				page: 1,
				export_class_detail_ids: [],
				source: 'RANGE_MEMBERSHIPS'
			}
		},
		getList() {
			if (this.view == 'calendar') {
				this.getClassesCalendar()
			} else {
				if (this.filters.class_detail_id && this.filters.reservation_date) {
					this.getClassEnrollment({ class_detail_id: this.filters.class_detail_id, class_date_id: this.filters.class_date_id, reservation_date: this.filters.reservation_date })
				} else {
					this.getEnrollmentList() 
				}
			}
		},
		filterStatus() {
			if (this.view == 'calendar') {
				this.populateCalendarItems(this.showDate.getFullYear() + '-' + (this.showDate.getMonth() + 1).toString().padStart(2, '0') + '-01')
			} else {
				this.getEnrollmentList()
			}
		},
		getClassesCalendar() {
			if (this.loading) { return }
			this.loading = true
			this.filters.start_date = this.showDate.getFullYear() + '-' + (this.showDate.getMonth() + 1).toString().padStart(2,'0') + '-01'

			let endMonth = this.showDate.getMonth() + 2 
			let currentYear = this.showDate.getFullYear()
			if (endMonth > 12) {
				currentYear += 1 
				endMonth = endMonth % 12
			} 
			this.filters.end_date = currentYear + '-' + (endMonth).toString().padStart(2,'0') + '-01'
			this.apiCall({ destination: 'get_list_calendar_classes', data: this.filters }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.calendarList = obj.list
					this.populateCalendarItems(this.showDate.getFullYear() + '-' + (this.showDate.getMonth() + 1).toString().padStart(2, '0') + '-01')
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getClassCalendar(classId) {
			this.loading = true
			let endMonth = this.showDate.getMonth() + 2 
			let currentYear = this.showDate.getFullYear()
			const currentDate = new Date()

			if (endMonth > 12) {
				currentYear += 1 
				endMonth = endMonth % 12
			} 
			let classFilter = {
				class_detail_id: classId,
				reservation_date: '',
				status: '',
				search_term: '',
				page: 1,
				source: 'RANGE_MEMBERSHIPS',
				start_date: currentDate,
				end_date: currentYear + '-' + (endMonth).toString().padStart(2,'0') + '-01',
				export_class_detail_ids: [],
				include_inactive: true,
			}
			classFilter = { ...this.filters, ...classFilter }
			this.apiCall({ destination: 'get_list_calendar_classes', data: classFilter }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					const classData = obj.list[classId];
					if (!classData || classData.dates.length === 0) {
						// inactive or not found
						this.invalidClass = true;
					} else {
						this.calendarList[classId] = classData;
					}
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setShowDate(d) {
			this.showDate = d;
			this.getClassesCalendar()
		},
		getEnrollmentList() {
			if (this.loading) { return }
			this.loading = true
			this.filters.start_date ? this.filters.start_date : this.showDate.getFullYear() + '-' + (this.showDate.getMonth() + 1).toString().padStart(2,'0') + '-01'

			this.apiCall({ destination: 'get_list_class_enrollment', data: this.filters }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.enrollmentList = obj.list
					// if calendarList is empty, get it
					if (Object.keys(this.calendarList).length == 0) {
						this.getClassesCalendar()
					}
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setSelectedCustomer(customer) {
			this.selectedCustomer = customer
			this.selectedCustomer.class_detail_id = this.filters.class_detail_id
			this.selectedCustomer.class_date_id = this.filters.class_date_id
			this.selectedCustomer.reservation_date = this.filters.reservation_date
			this.selectedCustomer.email_notifications = false
			this.selectedCustomer.text_notifications = false
		},
		backToEnrollmentList() {
			this.filters.class_detail_id = ''
			this.filters.class_date_id = ''
			this.selectedClassStartTime = ''
			this.selectedClassEndTime = ''
			this.selectedClassSeatsAvailable = null
			this.filters.reservation_date = ''
			this.getEnrollmentList()
		},
		backToCalendar() {
			this.view = 'calendar'
			this.$router.push('/range-memberships/class-calendar/calendar')
		},
		getSeatAvailability() {
			if (this.loading || (!this.enrollmentDetail || !this.enrollmentDetail.move_reservation_date)) { 
				return 
			}
			this.loading = true
			if (this.enrollmentDetail.move_reservation_date.includes(' ')) {
				this.enrollmentDetail.formatted_move_reservation_date = this.enrollmentDetail.move_reservation_date.split(' ')[0]
			} else {
				this.enrollmentDetail.formatted_move_reservation_date = this.enrollmentDetail.move_reservation_date
			}

			this.apiCall({ destination: 'get_item_class_enrollment', data: { 
				reservation_date: this.enrollmentDetail.formatted_move_reservation_date,
				class_detail_id: this.enrollmentDetail.class_detail_id, 
				class_date_id: this.enrollmentDetail.move_class_date_id || ''
			}}).then(obj => {
				if (obj.status == 'success') {
					this.loading = false
					// this.seatAvailability = obj.class_detail.seats_available - obj.list.length
					const totalSeats = Number(obj.class_detail?.seats_available || 0)
					const enrolledCount = Array.isArray(obj.list) ? obj.list.length : 0 
					this.seatAvailability = Math.max(totalSeats - enrolledCount, 0)
				} else {
					this.seatAvailability = '--'
					this.loading = false
				}
			}).catch(err => {
				this.loading = false
				this.seatAvailability = '--'
			})
		},
		getClassEnrollment(item) {
			if (this.loading) { return }
			this.loading = true
			
			if (item.start_time){
				this.selectedClassStartTime = item.start_time || '' 
			}
			
			if (item.end_time){
				this.selectedClassEndTime = item.end_time || ''
			}
			if (item.seats_available !== undefined && item.seats_available !== null) {
				this.selectedClassSeatsAvailable = Number(item.seats_available)
			}

			this.filters.class_detail_id = item.class_detail_id
			this.filters.class_date_id = item.class_date_id || this.filters.class_date_id || '' 
			this.filters.reservation_date = item.reservation_date
			this.apiCall({ destination: 'get_item_class_enrollment', data: this.filters }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					// this.enrollmentClassDetail = obj.class_detail
					this.enrollmentList = obj.list

					if (obj.class_detail && !Array.isArray(obj.class_detail)) {
						this.enrollmentClassDetail = obj.class_detail
					} else if (obj.list&& obj.list.length > 0) {
						this.enrollmentClassDetail = obj.list[0]
					} else {
						this.enrollmentClassDetail = {}
					}
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		resetMoveClass() {
			this.seatAvailability = '-';
			this.selectedClassStartTime = ''
			this.selectedClassEndTime = ''
			this.selectedClassSeatsAvailable = null
			if (this.enrollmentDetail) {
				this.enrollmentDetail.move_reservation_date = ''
				this.enrollmentDetail.move_class_date_id = ''
				this.enrollmentDetail.move_selection = ''
			}
			if (this.enrollmentDetail.class_detail_id) {
				this.getClassCalendar(this.enrollmentDetail.class_detail_id);
			}
		},
		exportList() {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Getting export...'
			if (!this.filters.class_detail_id) {
				this.filters.export_class_detail_ids = []
				// get all class_detail_ids from enrollmentList object
				for (const [index, detail] of Object.entries(this.enrollmentList)) {
					this.filters.export_class_detail_ids.push(detail.class_detail_id)
				}
			}
			this.apiCall({ destination: 'export_class_enrollment', data: this.filters }).then(obj => {
				this.loading = false
				this.filters.export_class_detail_ids = []
				this.messageStatus = obj.status
				if (obj.status == 'success' && obj.download_url) {
					this.message = 'Downloading export file...'
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = obj.download_url
						this.message = false
					}, 1000)
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		populateCalendarItems(calendarStartDate, forMove) {
			this.loading = true
			let useCalendarList = this.calendarList
			let calculatedCalendarItems = []
			if (forMove) {
				useCalendarList = { forMove: this.calendarList[forMove] }
				// calendar view
				if (!useCalendarList['forMove'] && !this.invalidClass) {
					this.getClassCalendar(forMove)
				}
			} else {
				this.calendarItems = []
			}
			for (const [classDetailId, detail] of Object.entries(useCalendarList)) {
				if (!forMove) {
					this.classList[classDetailId] = detail.description
				}
				// get start and end date / time, regardless of how many sessions in the set
				let startDate = detail.dates[0].date
				let startTime = detail.dates[0].start_time
				let endDate = detail.dates[detail.dates.length - 1].date
				let endTime = detail.dates[detail.dates.length - 1].end_time
				// recurring?
				if (detail.recurring) {
					let calendarStart = new Date(calendarStartDate)
					let calendarEnd = new Date(calendarStart.getFullYear(), calendarStart.getMonth()+2, 1) // first day of next month
					if (forMove) {
						calendarEnd = new Date(calendarStart.getFullYear(), calendarStart.getMonth()+11, 1) // next 12 months
					}
					let formattedCalendarEnd = (calendarEnd.getFullYear()+'-'+(calendarEnd.getMonth()+1).toString().padStart(2,'0')+'-'+(calendarEnd.getDate()+1).toString().padStart(2,'0'))
					// is there a repeat end date?
					if (detail.class_frequency_end_date) {
						let freqencyEnd = new Date(detail.class_frequency_end_date)
						freqencyEnd.setDate(freqencyEnd.getDate() + 1)
						if (freqencyEnd.getTime() < calendarEnd.getTime()) {
							calendarEnd = freqencyEnd;
						}
					}
					let index = 0
					let dEnd = new Date(endDate)
					switch (detail.class_frequency_code) {
						case 'DAY':
							for (let d = new Date(startDate); d <= calendarEnd; d.setDate(d.getDate() + 1)) {
								if (forMove && d < calendarStart) {
									continue
								}
								let formattedStartDate = (d.getFullYear()+'-'+(d.getMonth()+1).toString().padStart(2,'0')+'-'+(d.getDate()+1).toString().padStart(2,'0'))
								let formattedEndDate = (dEnd.getFullYear()+'-'+(dEnd.getMonth()+1).toString().padStart(2,'0')+'-'+(dEnd.getDate()+1).toString().padStart(2,'0'))
								let description = detail.description
								if (detail.dates[0].multi_session) {
									description += " (x" + (detail.dates[0].session_count + 1) + ')'
								}
								let seatsAvailable = detail.seats_available
								// search array detail.reservations where date = formattedEndDate
								let obj = detail.reservations.find(o => o.date == formattedStartDate);
								if (obj != undefined) {
									seatsAvailable -= obj.reservations
								}
								if (forMove) {
									calculatedCalendarItems.push({ id: detail.class_detail_id + '_' + index, move_key: `${detail.class_detail_id}|${detail.dates[0].class_date_id || ''}|${formattedStartDate}|${startTime}|${endTime}`, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description, seats_available: seatsAvailable })
									index++
								} else {
									let doAdd = true
									if (formattedStartDate < calendarStartDate) {
										doAdd = false
									}
									if (formattedEndDate > formattedCalendarEnd) {
										doAdd = false
									}
									if (this.filters.status == 'full' && seatsAvailable > 0) {
										doAdd = false
									}
									if (this.filters.status == 'available' && seatsAvailable < 1) {
										doAdd = false
									}
									if (doAdd) {
										description += "<br><i>" + seatsAvailable + " seat" + (seatsAvailable > 1 ? "s" : "") + " available</i>"
										this.calendarItems.push({ id: detail.class_detail_id + '_' + index++, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, seats_available: seatsAvailable, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description })
									}
								}
								dEnd.setDate(dEnd.getDate() + 1)
							}
							break;
						case 'WEEK':
							let multiplier = detail.class_frequency_unit || 1
							for (let d = new Date(startDate); d <= calendarEnd; d.setDate(d.getDate() + (7 * multiplier))) {
								if (forMove && d < calendarStart) {
									continue
								}
								let formattedStartDate = (d.getFullYear()+'-'+(d.getMonth()+1).toString().padStart(2,'0')+'-'+(d.getDate()+1).toString().padStart(2,'0'))
								let formattedEndDate = (dEnd.getFullYear()+'-'+(dEnd.getMonth()+1).toString().padStart(2,'0')+'-'+(dEnd.getDate()+1).toString().padStart(2,'0'))
								let description = detail.description
								if (detail.dates[0].multi_session) {
									description += " (x" + (detail.dates[0].session_count + 1) + ')'
								}
								let seatsAvailable = detail.seats_available
								// search array detail.reservations where date = formattedEndDate
								let obj = detail.reservations.find(o => o.date == formattedStartDate);
								if (obj != undefined) {
									seatsAvailable -= obj.reservations
								}
								if (forMove) {
									calculatedCalendarItems.push({ id: detail.class_detail_id + '_' + index, move_key: `${detail.class_detail_id}|${detail.dates[0].class_date_id || ''}|${formattedStartDate}|${startTime}|${endTime}`, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description, seats_available: seatsAvailable })
									index++
								} else {
									let doAdd = true
									if (formattedStartDate < calendarStartDate) {
										doAdd = false
									}
									if (formattedEndDate > formattedCalendarEnd) {
										doAdd = false
									}
									if (this.filters.status == 'full' && seatsAvailable > 0) {
										doAdd = false
									}
									if (this.filters.status == 'available' && seatsAvailable < 1) {
										doAdd = false
									}
									if (doAdd) {
										description += "<br><i>" + seatsAvailable + " seat" + (seatsAvailable > 1 ? "s" : "") + " available</i>"
										this.calendarItems.push({ id: detail.class_detail_id + '_' + index++, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, seats_available: seatsAvailable, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description })
									}
								}
								dEnd.setDate(dEnd.getDate() + (7 * multiplier))
							}
							break;
						case 'MONTH':
							let startDateParts = startDate.split('-')
							let startDateObject = new Date(startDateParts[0], startDateParts[1] - 1, startDateParts[2])
							// don't populate calendar if it's before class start year + month
							if ((calendarStart.getFullYear() == startDateObject.getFullYear()) && ((calendarStart.getMonth() + 1) < startDateObject.getMonth())) {
								break
							}
							let startDayOfMonth = startDateObject.getDate()
							let endDateParts = endDate.split('-')
							let endDateObject = new Date(endDateParts[0], endDateParts[1] - 1, endDateParts[2])
							let endDayOfMonth = endDateObject.getDate()
							if (detail.class_frequency_month_as_date != 1) {
								let dayOfWeek = new Date(startDateObject).getDay()
								let ordinal = Math.ceil(startDayOfMonth / 7)
								let ordinalIndex = 1

								//  reset to start of the month
								const [year, month] = calendarStartDate.split('-').map(Number);
								calendarStart = new Date(year, month - 1, 1);
								calendarEnd = new Date(calendarStart)
								calendarEnd.setMonth(calendarEnd.getMonth() + 12)

								// iterate through each day in the calendar month
								for (let d = calendarStart; d <= calendarEnd; d.setDate(d.getDate() + 1)) {
									if (forMove && d < calendarStart) {
										continue
									}
									if (d.getDay() == dayOfWeek) { // it's the right day of the week!
										if (ordinalIndex == ordinal) { // it's the right nth day of month!
											let formattedStartDate = (d.getFullYear()+'-'+(d.getMonth()+1).toString().padStart(2,'0')+'-'+d.getDate().toString().padStart(2,'0'))
											let formattedEndDate = (d.getFullYear()+'-'+(d.getMonth()+1).toString().padStart(2,'0')+'-'+d.getDate().toString().padStart(2,'0'))
											let description = detail.description
											if (detail.dates[0].multi_session) {
												description += " (x" + (detail.dates[0].session_count + 1) + ')'
											}
											let seatsAvailable = detail.seats_available
											// search array detail.reservations where date = formattedEndDate
											let obj = detail.reservations.find(o => o.date == formattedStartDate);
											if (obj !== undefined) {
												seatsAvailable -= obj.reservations
											}
											if (forMove) {
												calculatedCalendarItems.push({ id: detail.class_detail_id + '_' + index++, move_key: `${detail.class_detail_id}|${detail.dates[0].class_date_id || ''}|${formattedStartDate}|${startTime}|${endTime}`, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description, seats_available: seatsAvailable })
												ordinalIndex = 1
												d.setMonth(d.getMonth() + 1)
												d.setDate(0)
												continue
											} else {
												let doAdd = true
												if (formattedStartDate < calendarStartDate) {
													doAdd = false
												}
												if (formattedEndDate > formattedCalendarEnd) {
													doAdd = false
												}
												if (this.filters.status == 'full' && seatsAvailable > 0) {
													doAdd = false
												}
												if (this.filters.status == 'available' && seatsAvailable < 1) {
													doAdd = false
												}
												if (doAdd) {
													description += "<br><i>" + seatsAvailable + " seat" + (seatsAvailable > 1 ? "s" : "") + " available</i>"
													this.calendarItems.push({ id: detail.class_detail_id + '_' + index++, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, seats_available: seatsAvailable, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description })
												}
											}
											break
										} else {
											ordinalIndex++
										}
									} else {
										// reset ordinal if iteration hits last day - edge case: class falls on 31ist, etc
										const lastDayInMonth = new Date(d.getFullYear(), d.getMonth(), 0).getDate();
										if (d.getDate() === lastDayInMonth) {
											ordinalIndex = 1
										}
									}
								}
							} else {
								let formattedStartDate = calendarStart.getFullYear()+'-'+(calendarStart.getMonth()+1).toString().padStart(2,'0')+'-'+(startDayOfMonth.toString().padStart(2,'0'))
								let formattedEndDate = calendarStart.getFullYear()+'-'+(calendarStart.getMonth()+1).toString().padStart(2,'0')+'-'+(endDayOfMonth.toString().padStart(2,'0'))
								let description = detail.description
								if (detail.dates[0].multi_session) {
									description += " (x" + (detail.dates[0].session_count + 1) + ')'
								}
								let seatsAvailable = detail.seats_available
								// search array detail.reservations where date = formattedEndDate
								let obj = detail.reservations.find(o => o.date == formattedStartDate);
								if (obj != undefined) {
									seatsAvailable -= obj.reservations
								}
								if (forMove) {
									calculatedCalendarItems.push({ id: detail.class_detail_id + '_' + index++, move_key: `${detail.class_detail_id}|${detail.dates[0].class_date_id || ''}|${formattedStartDate}|${startTime}|${endTime}`, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description, seats_available: seatsAvailable })
								} else {
									let doAdd = true
									if (formattedStartDate < calendarStartDate) {
										doAdd = false
									}
									if (formattedEndDate > formattedCalendarEnd) {
										doAdd = false
									}
									if (this.filters.status == 'full' && seatsAvailable > 0) {
										doAdd = false
									}
									if (this.filters.status == 'available' && seatsAvailable < 1) {
										doAdd = false
									}
									if (doAdd) {
										description += "<br><i>" + seatsAvailable + " seat" + (seatsAvailable > 1 ? "s" : "") + " available</i>"
										this.calendarItems.push({ id: detail.class_detail_id + '_' + index++, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[0].class_date_id || '', reservation_date: formattedStartDate, start_time: startTime, end_time: endTime, seats_available: seatsAvailable, startDate: formattedStartDate + ' ' + startTime, endDate: formattedEndDate + ' ' + endTime, title: description })
									}
								}
							}
							break;
					}
				} else {
					// iterate detail.dates array
					let startDateObject = new Date(calendarStartDate)
					let compareDate = startDateObject.getFullYear()+'-'+(startDateObject.getMonth()+1).toString().padStart(2,'0')+'-'+(startDateObject.getDate().toString().padStart(2,'0'))
					let calendarEnd = new Date(startDateObject.getFullYear(), startDateObject.getMonth()+2, 0)
					let compareEndDate = calendarEnd.getFullYear()+'-'+(calendarEnd.getMonth()+1).toString().padStart(2,'0')+'-'+(calendarEnd.getDate().toString().padStart(2,'0'))
					for (let i = 0; i < detail.dates.length; i++) {
						let seatsAvailable = detail.seats_available
						if (detail.dates[i].date >= compareDate) {
							let description = detail.description
							if (detail.dates[0].multi_session) {
								description += " (x" + (detail.dates[0].session_count + 1) + ')'
							}
							startDate = detail.dates[i].date
							startTime = detail.dates[i].start_time
							endDate = detail.dates[i].date
							endTime = detail.dates[i].end_time
							// search array detail.reservations where date = startDate
							let obj = detail.reservations.find(o => {
								if (o.date != startDate) {return false}
								if (o.class_date_id) { return String(o.class_date_id) === String(detail.dates[i].class_date_id || '') }
								return true
							})
							if (obj != undefined) {
								seatsAvailable -= obj.reservations
							}
							if (forMove) {
								calculatedCalendarItems.push({ id: detail.class_detail_id + '_' + (detail.dates[i].class_date_id || i), move_key: `${detail.class_detail_id}|${detail.dates[i].class_date_id || ''}|${startDate}|${startTime}|${endTime}`, class_detail_id: detail.class_detail_id, class_date_id: detail.dates[i].class_date_id || '', reservation_date: startDate, start_time: startTime, end_time: endTime, startDate: startDate + ' ' + startTime, endDate: endDate + ' ' + endTime, title: description, seats_available: seatsAvailable})
							} else {
								let doAdd = true
								if (startDate < calendarStartDate) {
									doAdd = false
								}
								if (endDate > compareEndDate) {
									doAdd = false
								}
								if (this.filters.status == 'full' && seatsAvailable > 0) {
									doAdd = false
								}
								if (this.filters.status == 'available' && seatsAvailable < 1) {
									doAdd = false
								}
								if (doAdd) {
									description += "<br><i>" + seatsAvailable + " seat" + (seatsAvailable > 1 ? "s" : "") + " available</i>"
									this.calendarItems.push({ id: detail.class_detail_id + '_' + startDate + '_' + (detail.dates[i].class_date_id || i), class_detail_id: detail.class_detail_id, class_date_id: detail.dates[i].class_date_id || '', reservation_date: startDate, start_time: startTime, end_time: endTime, seats_available: seatsAvailable, startDate: startDate + ' ' + startTime, endDate: endDate + ' ' + endTime, title: description })
								}
							}
						}
					}

				}
			}
			this.loading = false
			if (forMove) {
				return calculatedCalendarItems
			}
		},
		changeMonth(event) {
			// this.populateCalendarItems(event.periodStart.getFullYear() + '-' + (event.periodStart.getMonth() + 1).toString().padStart(2, '0') + '-01', false)
			//this.populateCalendarItems(this.showDate.getFullYear() + '-' + (this.showDate.getMonth() + 1).toString().padStart(2, '0') + '-01')
			//this.getClassesCalendar()
		},
		showCalendarItemDetail(event) {
			const originalItem = event.originalItem || event
			let detailParts = String(originalItem.id || event.id || '').split('_')

			this.filters.reservation_date = event.startDate.getFullYear() + '-' + (event.startDate.getMonth()+1).toString().padStart(2,'0') + '-' + event.startDate.getDate().toString().padStart(2,'0')
			this.filters.class_detail_id = originalItem.class_detail_id || event.class_detail_id || detailParts[0]
			this.filters.class_date_id = originalItem.class_date_id || event.class_date_id || detailParts[2] ||''

			this.selectedClassStartTime = originalItem.start_time || ''
			this.selectedClassEndTime = originalItem.end_time || ''
			this.selectedClassSeatsAvailable = originalItem.seats_available !== undefined && originalItem.seats_available !== null ? Number(originalItem.seats_available) : null

			this.view = 'enrollment'
			this.$router.push('/range-memberships/class-calendar/enrollment?from=calendar')
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		contactDetail(enrollment) {
			this.seatAvailability = '--'
			this.enrollmentDetail = { ...enrollment }
			this.enrollmentDetail.move_reservation_date = ''
			this.enrollmentDetail.move_class_date_id = ''
			this.enrollmentDetail.move_selection = '' 
		},
		cancelEnrollment() {
			if (this.saving) { return }
			this.saving = 'cancel_enrollment'
			let postObject = {
				class_detail_id: this.enrollmentDetail.class_detail_id,
				class_date_id: this.enrollmentDetail.class_date_id || this.filters.class_date_id || '', 
				contact_id: this.enrollmentDetail.contact_id,
				reservation_date: this.enrollmentDetail.reservation_date,
				remove: true
			}
			this.apiCall({ destination: 'enroll_customer_in_class', data: postObject }).then(obj => {
				this.saving = ''
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.enrollmentDetail = {}
					this.confirmCancelEnrollment = false
					this.getClassEnrollment({class_detail_id: this.filters.class_detail_id, class_date_id: this.filters.class_date_id, reservation_date: this.filters.reservation_date})
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		searchCustomers() {
			if (this.searching || !this.customerSearchTerm) { return }
			this.searching = true
			this.customerList = []
			this.selectedCustomer = {}
			this.searchMessage = 'Searching...'
			this.apiCall({ destination: 'get_list_contacts', data: { search_term: this.customerSearchTerm } }).then(obj => {
				this.searching = false
				if (obj.list.length > 0) {
					this.customerList = obj.list
					this.searchMessage = ''
				} else {
					this.searchMessage = 'No matching customers found!'
				}
			}).catch(err => {
				console.log(err)
			})			
		},
		addToEnrollment(customer) {
			if (this.saving || !customer.contact_id) { return }
			this.saving = 'add_enrollment'
			let postObject = {
				class_detail_id: this.filters.class_detail_id,
				class_date_id: this.filters.class_date_id, 
				reservation_date: this.filters.reservation_date,
				contact_id: customer.contact_id,
				email_notifications: customer.email_notifications,
				text_notifications: customer.text_notifications
			}
			this.apiCall({ destination: 'enroll_customer_in_class', data: postObject }).then(obj => {
				this.saving = ''
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.searchMessage = ''
					this.customerSearchTerm = ''
					this.customerList = []
					this.selectedCustomer = {}
					this.showAddEnrollment = false
					this.getClassEnrollment({class_detail_id: this.filters.class_detail_id, class_date_id: this.filters.class_date_id, reservation_date: this.filters.reservation_date})
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		moveEnrollment() {
			if (this.saving) { return }
			if (!this.enrollmentDetail.class_detail_id || !this.enrollmentDetail.move_reservation_date) {
				this.message = 'Please select a class and date to move this enrollment to.'
				return
			}
			this.saving = 'move_enrollment'
			let postObject = {
				order_id: this.enrollmentDetail.order_id,
				order_item_id: this.enrollmentDetail.order_item_id,
				contact_id: this.enrollmentDetail.contact_id,
				class_detail_id: this.filters.class_detail_id,
				class_date_id: this.enrollmentDetail.class_date_id || this.filters.class_date_id || '',
				reservation_date: this.enrollmentDetail.reservation_date,
				move_class_detail_id: this.enrollmentDetail.class_detail_id,
				move_class_date_id: this.enrollmentDetail.move_class_date_id || '',
				move_reservation_date: this.enrollmentDetail.move_reservation_date,
			}
			this.apiCall({ destination: 'move_customer_enrollment', data: postObject }).then(obj => {
				this.saving = ''
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.enrollmentDetail = {}
					this.getClassEnrollment({class_detail_id: this.filters.class_detail_id, class_date_id: this.filters.class_date_id, reservation_date: this.filters.reservation_date})
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		}, 
		setMoveClassDateId(){
			this.enrollmentDetail.move_class_date_id = ''
			this.enrollmentDetail.move_reservation_date = '' 
			
			const match = this.enrollmentDetailDetailDates.find(date => date.move_key === this.enrollmentDetail.move_selection)

			if (match) {
				this.enrollmentDetail.move_class_date_id = match.class_date_id || ''
				this.enrollmentDetail.move_reservation_date = match.reservation_date || String(match.startDate).split(' ')[0]
			}
			this.getSeatAvailability()
		}, 
		formatMoveOption(date) {
			const formattedDate = this.$moment(date.reservation_date || date.startDate).format('MM/DD/YYYY')
			 let timeLabel = '' 

			 if (date.start_time && date.end_time) {
				timeLabel = ` (${date.start_time} - ${date.end_time})`
			 } else {
				const parts = String(date.startDate).split(' ')
				if (parts.length > 1) {
					timeLabel = ` ${parts[1]}`
				}
			 }

			 return `${formattedDate}${timeLabel}`
		}
	}
}
</script>

<style lang="scss">
// NOTE: we can style elements inside a component IF scss is NOT scoped
.theme-default .cv-header .periodLabel {
	display: block;
	text-align: right;
	font-size: 1.75em;
}
.cv-week {
	min-height: 10em;
}
.cv-day {
	min-height: 10em;
}
</style>